import { render, staticRenderFns } from "./comp_CheckoutStep-payment--done.vue?vue&type=template&id=c299159c&scoped=true&"
import script from "./comp_CheckoutStep-payment--done.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-payment--done.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-payment--done.vue?vue&type=style&index=0&id=c299159c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c299159c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
